import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS,HttpEventType  } from '@angular/common/http';
import { RouterModule } from '@angular/router';
// used to create fake backend
import { fakeBackendProvider } from './helpers';
import {TabMenuModule} from 'primeng/tabmenu';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor, ErrorInterceptor } from './helpers';
import { TableModule } from 'primeng/table';
import { TopLayoutComponent } from './layouts/top-layout.component';
import { HomeLayoutComponent } from './layouts/home-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';
import { LeftmenuLayoutComponent } from './layouts/leftmenu-layout.component';
import { LoginModule } from './login/login.module'
import { HomeModule } from './dealer/home.module'
import {PanelModule} from 'primeng/panel';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import {DialogModule} from 'primeng/dialog';
import { SpinnerComponent } from './spinner.component';
import {MultiSelectModule} from 'primeng/multiselect';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MomentModule } from 'ngx-moment';
import { FileuploadModule } from './file-upload/fileupload.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { GoogleChartsModule } from 'angular-google-charts'
@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        RouterModule,
        HttpClientModule,
        AppRoutingModule,
        TableModule,
        LoginModule,
        HomeModule,
        PanelModule,
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        DialogModule,
        MultiSelectModule,
        TabMenuModule,
        MomentModule,
        FileuploadModule,
        DashboardModule,
        NgxPermissionsModule.forRoot(),
        GoogleChartsModule
    ],
    declarations: [
        AppComponent,
        TopLayoutComponent,
        HomeLayoutComponent,
        SimpleLayoutComponent,
        SpinnerComponent,
        LeftmenuLayoutComponent
        
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        // provider used to create fake backend
        fakeBackendProvider
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }